/**
 * ScreenerService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class ScreenerService {
    getAllCountries = () => {
        return apiClient.get("/screener/company/countries");
    }

    getExchangesByCountry = (country) => {
        return apiClient.post("/screener/countries/exchange", {country});
    }

    getCityByCountryAndExchange = (country, exchange) => {
        return apiClient.post("/screener/city", {country, exchange});
    }

    getSectorByExchange = (exchange) => {
        return apiClient.post("/getSectorByExchange", {exchange});
    }

    getIndustryByExchangeSector = (exchange, sector) => {
        return apiClient.post("/getIndustryByExchangeSector", {exchange, sector});
    }

    getCategories = () => {
        return apiClient.get("/screener/getCategories");
    }

    getMetricsByCategory = (category) => {
        return apiClient.post("/screener/getMetrics", {category});
    }

    getCompanies = (body) => {
        return apiClient.post("/screener/getCompanies/filers", body);
    }

    getCompaniesData = (symbols, period) => {
        return apiClient.post("/screener/company/data", {symbols, period});
    }

    getCompaniesDataWithMetricFilters = (body) => {
        return apiClient.post("screener/filter/companies", body);
    }
}
